import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { i18n } from '@app/shared/language/i18n';
import { AppUpdateService } from '@shared/services/app-update/app-update.service';
import { AppUpdateToastTemplate } from '@shared/services/app-update/app-update.types';

@Component({
  selector: 'math-app-update-toast',
  imports: [TranslateModule, NzButtonModule, NzFlexModule],
  templateUrl: './app-update-toast.component.html',
  styleUrl: './app-update-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateToastComponent {
  private readonly appUpdateService = inject(AppUpdateService);

  protected readonly i18n = i18n;

  @ViewChild('toast', { static: true })
  public readonly templateRef!: AppUpdateToastTemplate;

  protected onReload(): void {
    this.appUpdateService.reload();
  }
}
